/*
 * Monkey patch the `console` object.
 * Ensures that `console` is available
 * across all browsers and supports the
 * methods log/info/debug/warn/error.
 * !! IMPORTANT !! This file should not use jquery since it is loaded at the
 * very top of all pages and we use multiple versions of jquery across the site
 */
if (typeof(console) === "undefined") {
  console = {};
}

/*
 * Patch console.log separately.
 * Some browsers support log but not
 * other functions.
 */
if (!console['log']) {
  console.log = function(msg) {};
}

/*
 * Patch info/debug/warn/error.
 * If not defined, then have it behave
 * like console.log.
 */
var consoleFcns = ['info', 'debug', 'warn', 'error'];
for (var i = 0; i < consoleFcns.length; i++) {
  var fname = consoleFcns[i];
  if (!console[fname]) {
    console[fname] = function(msg) {
      console.log(fname + ': ' + msg);  // ex: console.debug('egg') => 'debug: egg'
    };
  }
}
